import React from 'react';
import { ValidationGroup } from '@bingads-webui-react/primitive-validation';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { TaxTypeFormPropTypes } from '../shapes';
import { LegalIdentifierHintI18nKey, LegalIdentifierNumberPilot } from '../constants';
import { registerTaxform } from '../taxform-store';
import { LegalIdentifierNumberField } from '../controls/legal-identitfier-number-field';
import { EmptyViewTaxForm } from './viewtaxforms/empty-viewtaxform';
import { withViewTaxFormWithFilledEmptyTaxValue, withTaxFormByPilot } from '../utils';
import { EmptyTaxForm } from './empty-taxform';
import { useValidationI18n } from '../hooks/use-i18n';

const { CountryCode, TaxType } = Constants;

const RussiaTaxSchema = {
  name: 'Russia Taxation Validation Schema',
  type: 'object',
  properties: {
    [TaxType.LegalIdentifier]: {
      type: 'string',
      required: true,
    },
  },
};

const RussiaTaxForm = ({
  i18n,
  data,
  onValidate,
  showLineByLineFormGroup,
  alwaysShowError,
}) => {
  const validationI18n = useValidationI18n(i18n);
  return (
    <ValidationGroup
      validationProps={{
        i18n: validationI18n,
        onValidate,
        data,
        schema: RussiaTaxSchema,
      }}
    >
      <LegalIdentifierNumberField
        i18n={i18n}
        showLineByLineFormGroup={showLineByLineFormGroup}
        alwaysShowError={alwaysShowError}
        hintContent={i18n.getString(LegalIdentifierHintI18nKey[CountryCode.RU])}
      />
    </ValidationGroup>
  );
};

RussiaTaxForm.propTypes = TaxTypeFormPropTypes;

const pilotFlag = LegalIdentifierNumberPilot;
const TaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: RussiaTaxForm, DefaultForm: EmptyTaxForm });
const RussiaViewTaxForm = withViewTaxFormWithFilledEmptyTaxValue({ getTaxSchema: () => RussiaTaxSchema });
const ViewTaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: RussiaViewTaxForm, DefaultForm: EmptyViewTaxForm });

registerTaxform('/RU/', TaxForm, ViewTaxForm);
